import React from "react"
import ReactDOM from "react-dom/client"
import ReactGA from 'react-ga4';
import "./index.css"
import App from "./App"

ReactGA.initialize('G-H79L67YTGG');

window.Buffer = window.Buffer || require("buffer").Buffer

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
)

root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>
)
